var PageMySettings = (function ($) {

    PageMySettings = function (options) {
        var that = this;

        options = options || {};

        // DOM
        that.$wrapper = options['$wrapper'];

        that.$checkbox_special_offers_subscription = that.$wrapper.find('.js-checkbox-special-offers-subscription');
        that.$checkbox_flight_info_subscription = that.$wrapper.find('.js-checkbox-flight-info-subscription');

        that.$edit_data_call = that.$wrapper.find('.js-edit-data-call');
        that.$confirm_phone_call = that.$wrapper.find('.js-confirm-phone-call');
        that.$add_phone_call = that.$wrapper.find('.js-add-phone-call');
        that.$confirm_email_call = that.$wrapper.find('.js-confirm-email-call');
        that.$add_email_call = that.$wrapper.find('.js-add-email-call');
        that.$drawer_personal_data_html = that.$wrapper.find('.js-drawer-personal-data-html');

        that.$edit_password_call = that.$wrapper.find('.js-edit-password-call');

        // CONST
        that.locales = options['locales'] || {};
        that.modals = options['modals'] || {};
        that.drawers = options['drawers'] || {};
        that.contact_data = options['contact_data'] || {};

        that.notifier_time = 4000;
        that.class = {
            is_stick: 'is-stick'
        };
        that.selectors = {
            sticky_observer: '.js-sticky-observer',
        };

        // DYNAMIC VARS
        that.is_locked = false;

        // INIT
        that.init();
    };

    PageMySettings.prototype.init = function () {
        var that = this;

        $.sa.stickyObserver(that.selectors.sticky_observer, that.class.is_stick);

        that.__initPersonalDataBlock();

        that.__initSubscriptionBlock();

        that.__initAccountActionsBlock();
    };

    /**
     * @private
     */
    PageMySettings.prototype.__initPersonalDataBlock = function () {
        var that = this;

        that.$edit_data_call.on('click', function () {
            that.__renderPersonalDataDrawer();
        });
        that.$confirm_phone_call.on('click', function () {
            that.__renderConfirmPhoneModal();
        });
        that.$add_phone_call.on('click', function () {
            that.__renderAddPhoneModal();
        });
        that.$confirm_email_call.on('click', function () {
            that.__renderConfirmEmailModal();
        });
        that.$add_email_call.on('click', function () {
            that.__renderAddEmailModal();
        });
    };

    /**
     * @private
     */
    PageMySettings.prototype.__initSubscriptionBlock = function () {
        var that = this;

        that.$checkbox_special_offers_subscription.on('change', function () {
            that.__saveSubscriptionSetting({
                name: $(this).attr('name'),
                value: $(this).prop('checked') ? 1 : 0
            }, $(this));
        });

        that.$checkbox_flight_info_subscription.on('change', function () {
            that.__saveSubscriptionSetting({
                name: $(this).attr('name'),
                value: $(this).prop('checked') ? 1 : 0
            }, $(this));
        });
    };

    /**
     * @private
     */
    PageMySettings.prototype.__initAccountActionsBlock = function () {
        var that = this;

        if (that.modals['edit_password'] && that.modals['edit_password'].length) {
            that.$edit_password_call.on('click', function () {
                that.__renderEditPasswordModal();
            });
        }
    };

    /**
     * @private
     */
    PageMySettings.prototype.__renderPersonalDataDrawer = function () {
        var that = this;

        $.uiDrawer({
            $wrapper: $(that.drawers['personal_data']).clone(),
            position: 'right',
            size: 'small',
            mobile_fullscreen: true,
            close_on_avia_before_load: false
        });
    };

    PageMySettings.prototype.__renderConfirmPhoneModal = function () {
        var that = this;

        $.uiModal({
            mobile_fullscreen: true,
            header_title: that.modals['confirm_phone']['title'],
            content: that.modals['confirm_phone']['content'],
            onOpen: function ($modal_wrapper) {
                $modal_wrapper.addClass('actionform-modal');
                $modal_wrapper.find('.js-phone').val(that.contact_data.phone || '');
            },
            onBgClick: function () {
                return false;
            }
        });
    };

    PageMySettings.prototype.__renderAddPhoneModal = function () {
        var that = this;

        $.uiModal({
            mobile_fullscreen: true,
            header_title: that.modals['add_phone']['title'],
            content: that.modals['add_phone']['content'],
            onOpen: function ($modal_wrapper) {
                $modal_wrapper.addClass('actionform-modal');
            },
            onBgClick: function () {
                return false;
            }
        });
    };

    PageMySettings.prototype.__renderConfirmEmailModal = function () {
        var that = this;

        $.uiModal({
            mobile_fullscreen: true,
            header_title: that.modals['confirm_email']['title'],
            content: that.modals['confirm_email']['content'],
            onOpen: function ($modal_wrapper) {
                var $input_login = $modal_wrapper.find('.js-login'),
                    $input_login_wrapper = $input_login.parent('.input');

                $modal_wrapper.addClass('actionform-modal');
                $input_login.val(that.contact_data.email || '');
                $input_login_wrapper.addClass('not-empty');
            },
            onBgClick: function () {
                return false;
            }
        });
    };

    PageMySettings.prototype.__renderAddEmailModal = function () {
        var that = this;

        $.uiModal({
            mobile_fullscreen: true,
            header_title: that.modals['add_email']['title'],
            content: that.modals['add_email']['content'],
            onOpen: function ($modal_wrapper) {
                $modal_wrapper.addClass('actionform-modal');
            },
            onBgClick: function () {
                return false;
            }
        });
    };

    /**
     * @private
     */
    PageMySettings.prototype.__saveSubscriptionSetting = function (data, $button) {
        var that = this,
            href = $.sa.build_url('my/settings/subscription-save/');

        that.__toggleButtonAvailability($button, false);
        $.post(href, data)
            .done(function (response) {
                if (response.status === 'ok') {
                    that.__handleSaveSubscriptionSettingSuccess();
                } else if (response.status === 'fail') {
                    that.__handleSaveSubscriptionSettingError($button);
                }
            })
            .fail(function () {
                that.__handleSaveSubscriptionSettingError($button);
            })
            .always(function() {
                that.__toggleButtonAvailability($button, true);
            });
    };

    /**
     * @private
     */
    PageMySettings.prototype.__handleSaveSubscriptionSettingSuccess = function() {
        var that = this;

        $.sa.notifier.show({
            title: that.locales['subscription_setting_success_notify_title'],
            notifier_class: $.sa.notifier.class.success,
            time: that.notifier_time,
        });
    };

    /**
     * @private
     */
    PageMySettings.prototype.__handleSaveSubscriptionSettingError = function($button) {
        var that = this;

        $button.prop('checked', !$button.prop('checked'));

        $.sa.notifier.show({
            title: $.sa.locales['error'],
            content: $.sa.locales['something_went_wrong'],
            notifier_class: $.sa.notifier.class.error,
            time: that.notifier_time,
        });
    };

    /**
     * @private
     */
    PageMySettings.prototype.__toggleButtonAvailability = function ($button, is_available) {
        $button.prop('disabled', !is_available);
    };

    /**
     * @private
     */
    PageMySettings.prototype.__renderEditPasswordModal = function () {
        var that = this;

        if (!that.modals['edit_password'] || !that.modals['edit_password'].length) {
            return;
        }

        that.edit_password_modal = $.uiModal({
            html: that.modals['edit_password'],
            onClose: function () {
                that.edit_password_modal = null;
            }
        });
    };

    return PageMySettings;
})($);
